module.exports = __webpack_public_path__ + "static/wasabi-4-ce9f73818ff450a518b1f7939e2667dd.png";